<mat-form-field class="w-full" appearance="outline" [floatLabel]="floatLabel">
  <mat-label i18n="@@product_type">Product Type</mat-label>
  <mat-select
    (selectionChange)="categoryChange($event.value)"
    [formControl]="ctrl"
  >
    <mat-option *ngIf="showAll" value="" i18n="@@all">All</mat-option>
    <mat-option *ngFor="let category of categories" [value]="category.value">
      {{ category.label }}
    </mat-option>
  </mat-select>
</mat-form-field>
